<template>
  <div>
    <search></search>
    <div style="width:1200px;margin:auto;">
      <div style="margin-top:20px;" class="operationBox">
        <div style="width:1200px;" class="goodsTop">
          <ul>
            <li v-show="false" ><span>综合</span><i></i></li>
            <li :class="{active:isClick2}" @click="salesVolume"><span>销量</span><i :class="{active_:isClick2}"></i></li>
            <li :class="{active:isClick3}" @click="price_"><span>价格</span><i :class="{active1:isClick4,active2:isClick5}"></i></li>
          </ul>
        </div>
      </div>
      <div style="margin-bottom:20px;" class="GoodsListContentBox">
        <ul class="clearfix">
          <li v-for="(goods,index) in teamGoodsList" :key="index" @mouseenter="hover(index)" @mouseleave="leave(index)">
            <router-link tag="a" target="_blank" :to="{name:'goodsdetails',query: {goodsId:goods.goodsId}}">
              <div class="goodslistpicbox">
                <img :title="goods.goodsName" :src="goods.goodsHeadpicPath1?goods.goodsHeadpicPath1:noImg" width="225" height="225" :goodsId="goods.goodsId"/>
              </div>
            </router-link>
              <div class="goodslistprice clearfix_">
                <p class="fl">¥{{goods.price}} <span style="text-decoration:line-through;color:#999;font-size:14px;">¥{{goods.originalPrice}}</span></p>
                <p class="fr teamPriceAndNum clearfix_"><span class="fl"></span><i class="fl">{{goods.val}}人拼</i></p>
              </div>
            <router-link tag="a" target="_blank" :to="{name:'goodsdetails',query: {goodsId:goods.goodsId}}">
              <div class="goodslistnamebox">
                <p :title="goods.name">{{goods.goodsName}}</p>
              </div>
            </router-link>
            <div class="clearfix_">
              <div class="goodslistBtnBox fl" v-show="Accord === index" @click="goToGoods(goods.goodsId)">查看详情</div>
              <div class="goodslistBtnBox fl" v-show="Accord === index" @click="goToGoods(goods.goodsId)">加入购物车</div>
            </div>
          </li> 
        </ul>
        <div class="noGoods" v-show="iscategoryList">暂时没有商品哦~！快去看看其他好商品吧~！</div>
      </div>
      <div v-show="total" style="text-align:center;" class="pagebox">
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="teamGoodsPage"
            :page-size="12"
            layout="prev, pager, next, jumper"
            :total="this.total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
import search from '@/components/index/search'
export default {
  components:{
    search
  },
  data(){
    return{
      teamGoodsPage:1,
      teamGoodsList:'',
      noImg:require("@/assets/img/aa.png"),
      teamGoodsPage:1,
      iscategoryList:false,
      total:0,
      Accord:-1,
      isClick2:false,
      isClick3:false,
      isClick4:false,
      isClick5:false,
      salesVolumeState:false,
            minormax:0,
    }
  },
  mounted:function(){
    this.getTeamGoods(this.teamGoodsPage)
  },
  methods:{
    goToGoods:function(goodsId){
      var t_=this
      var href=this.$router.resolve( {name:'goodsdetails',query: {goodsId:goodsId}})
      return window.open(href.href,'_blank')
    },
    price_:function(){
      var t_=this
      t_.salesVolumeState=0
      if(t_.isClick5){
        t_.isClick2=false
        t_.isClick3=true
        t_.isClick4=true
        t_.isClick5=false
        t_.minormax=2
      }else{
        t_.isClick2=false
        t_.isClick3=true
        t_.isClick4=false
        t_.isClick5=true
        t_.minormax=1
      }
      t_.getTeamGoods(1)
      t_.currentPage3=1
    },
    salesVolume:function(){
      var t_=this
      t_.isClick2=true
      t_.isClick3=false
      t_.isClick4=false
      t_.isClick5=false
      t_.minormax=0
      if(t_.salesVolumeState==0){
        t_.salesVolumeState=1
      }else if(t_.salesVolumeState==1){
        t_.salesVolumeState=2
      }else if(t_.salesVolumeState==2){
        t_.salesVolumeState=1
      }
      t_.getTeamGoods(1)
      t_.currentPage3=1
    },
    handleSizeChange(val) {
    },
    handleCurrentChange(val) {
      this.teamGoodsPage=val
      this.teamGoodsList=[]
      this.getTeamGoods(val)
    },
    getTeamGoods:function(val){
      var t_=this
      var data0bj = {
          channel: 2,
          tamp:localStorage.tamp?localStorage.tamp:'',
          page:val,
          pagesize:12
      }
      if(this.salesVolumeState==1){
        data0bj.sortName = 'sum'
        data0bj.sort='1'
      }else if(this.salesVolumeState==2){
        data0bj.sortName = 'sum'
        data0bj.sort='2'
      }
      if(this.minormax==1){
        data0bj.sortName = 'price'
        data0bj.sort = '1'
      }else if(this.minormax==2){
        data0bj.sortName = 'price'
        data0bj.sort = '2'
      }
      var u = `${ip}spellGroupInterface/getCategoryById`
      axios.post(u,Qs.stringify(data0bj)).then(res=>{
        if(overtime(res.data.code)){
            localStorage.removeItem('tamp')
            localStorage.removeItem('name')
            return this.$router.push({
              path: '/LoginHome?state=1',
              query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
            });
            this.$router.go(0);
          }
          if(res.data.code==300){
            var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
            return window.open(href.href,'_blank')
          }
        if( res.data.code == 0 ){
          if(res.data.code==0){
            if(res.data.results.total==0)return t_.iscategoryList=true
            t_.teamGoodsList=res.data.results.rows
            t_.total=res.data.results.total
          }
        }
      })
    },
    hover:function (index) {
      this.Accord = index
    },
    leave:function (index) {
      this.Accord = null
    },
  }
}
</script>
<style>
  .operationBox{
    width: 100%;
    height: 40px;
    background: #F6F6F6;
    border: 1px solid #ccc;
    margin-bottom: 8px;
  }
  .goodsTop{
    width: 992px;
    height: 40px;
    border-bottom: 1px solid #ccc;
    margin: 0 auto;
  }
  .goodsTop ul{
    width: auto;
    height: 30px;
    margin-top: 8px;
    float: left;
    margin-left: 8px;
  }
  .goodsTop ul li{
    float: left;
    background: white;
    margin-right: 5px;
    border: 1px solid #EDEDED;
  }
  .goodsTop ul .active{
    background: #e4393c;
    color: #fff;
    border: 1px solid #e4393c;
  }
  .goodsTop ul li .active_{
    background: url(../../assets/img/a01.png);
  }
  .goodsTop ul li:nth-child(3) .active1{
    background: url(../../assets/img/a03.png);
  }
  .goodsTop ul li:nth-child(3) .active2{
    background: url(../../assets/img/a04.png);
  }
  .goodsTop ul li i{
    display: block;
    float: left;
    width: 7px;
    height: 11px;
    background: url(../../assets/img/a00.png);
    margin-top: 7px;
  }
  .goodsTop ul li:nth-child(3) i{
    background: url(../../assets/img/a02.png);
  }
  /* .pagebox{
    width: 100%;
    height: 40px;
    float: left;
    margin: 70px auto;
    text-align: center;
  } */
  .xiaoliang{
    background: url('../../assets/img/icon.png') 21px -317px;
  }
  .pingjia{
    background: url('../../assets/img/icon.png') 21px -317px;
  }
  .jiage{
    background: url('../../assets/img/icon.png') 21px -356px
  }
  .goodsTop ul .frist{
    color: white;
    background: #FF6600;
    width: 59px;
  }
  .goodsTop ul li{
    display: block;
    width: 44px;
    height: 23px;
    border: 1px solid #ccc;
    line-height: 24px;
    font-size: 12px;
    background: white;
    float: left;
    cursor: pointer;
    padding-left: 10px;
  }
  .goodsTop ul .pricebtn{
    background: url(/static/img/icon.d55c0a9.png) no-repeat 32px -355px;
  }
  .goodsTop ul .pricebtn span{
    display: block;
    width: 34px;
    float: left;
  }
  .goodsTop ul .salebtn{
    background: url(/static/img/icon.d55c0a9.png) no-repeat 32px -355px;;
  }
  .goodsTop ul .salebtn span{
    display: block;
    width: 34px;
    float: left;
  }
  .goodsTop ul li span{
    float: left;
    margin-right: 5px;
  }
  .GoodsListContentBox{
    /* padding: 0 23px; */
  }
  .GoodsListContentBox ul li{
    width: 224px;
    height: 352px;
     padding: 10px;
    margin-right: 72px;
    float: left;
    margin-bottom: 10px;
    border: 1px solid white;
  }
  .GoodsListContentBox ul li:nth-child(4n+0){
    margin-right: 0;
  }
  .GoodsListContentBox ul li:hover{
    border: 1px solid #eaeaea;
    border-radius: 3px;
    box-shadow: 0 0 1px #999;
  }
  .GoodsListContentBox ul li a{
    text-decoration: none;
  }
  .goodslistpicbox{
    height: 235px;
    border-bottom: 1px solid #EEEEEE;
  }
  .goodslistprice p{
    height: 45px;
    line-height: 45px;
    text-align: left;
    color: #FF6600;
    font-size: 22px;
  }
  .goodslistnamebox p{
    text-align: left;
    font-size: 12px;
    color: #313030;
    height: 35px;
    line-height: 19px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .goodslistnamebox p:hover{
    color: #FF6600;
    text-decoration: underline;
  }
  .goodslistoptionbox{
    width: 100%;
    height: 30px;
  }
  .goodslistoptionbox .goodslistLeftBox{
    width: 50%;
    height: 35px;
    float: left;
    text-align: left;
    line-height: 35px;
    color: #313030;
  }
  .goodslistoptionbox .goodslistLeftBox span{
    color: #2272C8;
    font-weight: 600;
  }
  .goodslistoptionbox .goodslistRightBox{
    float: left;
    text-align: right;
    width: 50%;
    height: 35px;
    line-height: 35px;
    color: #313030;
  }
  .goodslistBtnBox{
    cursor: pointer;
    width: 112px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #FF6600;
    font-size: 14px;
    border-top: 1px solid #eee;
    margin-top: 10px;
    border-right: 1px solid #eee;
    /*display: none;*/
  }
  .goodslistBtnBox:first-child{
    width: 111px;
  }
  .goodslistBtnBox:last-child{
    border-right: 0;
  }
   /* .el-pagination .el-pagination__jump{
    margin-top:-10px;
  } */
  .goodslistprice  .teamPriceAndNum{
    font-size: 14px;
  }
  .goodslistprice  .teamPriceAndNum span{
    margin-right: 5px;
  }
  .goodslistprice  .teamPriceAndNum  i{
    width: 55px;
    height: 18px;
    background:#f60;
    line-height: 18px;
    text-align: center;
    color:#fff;
    margin-top: 13px;
  }
  .pagebox .el-pagination__jump{
    margin-top:-9px;
  }
  .pagebox .el-pagination__jump .el-pagination__editor{
    top:9px;
  }
  .noGoods{
    text-align: center;
    padding: 20px 0;
  }
  @media screen and ( max-width: 1390px ) {
    .GoodsContents{
      width: 983px;
    }
    .goodsTop{
      width: 100%;
    }
    .GoodsListContentBox ul li{
      width: 233px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/goodsList/teamGoods.vue